import { useTranslation } from 'react-i18next'

import { AboutHotel } from 'entities/tour/ui/tour-detail/components/tabs-info/components/about-hotel'
import { AboutTour } from 'entities/tour/ui/tour-detail/components/tabs-info/components/about-tour'

import { AllIcons } from 'shared/ui/app-icon/types.ts'
import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'
import { InfoItem } from 'shared/ui/info-item'
import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'
import { ListInfoProps, ListItem } from './types.ts'

const getInfoItems = (): ListItem[] => [
  {
    name: 'tours_block.about_tour',
    subtitle: 'tours_block.flight_text',
    key: 'about_tour',
    element: AboutTour,
    icon: AllIcons.AIRPLANE_BIG,
    getProps: (aboutTourData, _aboutHotelData, hotelId) => ({
      data: aboutTourData,
      tourNumber: hotelId,
    }),
  },
  {
    name: 'tours_block.about_hotel',
    subtitle: 'tours_block.service_text',
    key: 'about_hotel',
    element: AboutHotel,
    icon: AllIcons.HOTEL,
    getProps: (_aboutTourData, aboutHotelData, hotelId) => ({
      data: aboutHotelData,
      tourNumber: hotelId,
    }),
  },
]

export const ListInfo = ({
  hotelId,
  aboutTourData,
  aboutHotelData,
}: ListInfoProps) => {
  const { t } = useTranslation()
  const { openDialog } = useDialogBottomSheet()

  const tabs = getInfoItems()

  const handleOpenTab = (key: string) => {
    const currentTabItem = tabs.find((item) => item.key === key)
    if (!currentTabItem) return

    const CurrentTabElement = currentTabItem.element
    const currentProps = currentTabItem.getProps(
      aboutTourData,
      aboutHotelData,
      hotelId,
    )

    openDialog({
      child: <CurrentTabElement {...currentProps} />,
      backgroundColor: 'var(--white)',
      maxHeight: '95vh',
    })
  }

  return (
    <Paper
      className={s.container}
      padding={[0, 16]}
    >
      {tabs.map((tab) => (
        <InfoItem
          key={tab.key}
          title={t(tab.name)}
          subtitle={t(tab.subtitle)}
          icon={tab.icon}
          onClick={() => handleOpenTab(tab.key)}
        />
      ))}
    </Paper>
  )
}
